import { createTheme  } from '@material-ui/core/styles';
export const theme = createTheme({
    typography: {},
    shape: { borderRadius: 4 },
    spacing: 8,
    overrides: {
        MuiTextField: {
            root: {
                borderRadius: 4,
                fontFamily: "Inter",

            },
        },
        MuiSelect: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            },
        },
        MuiMenuItem: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            }
        },
        MuiListItemText: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            }
        },
        MuiTypography: {
            body1: {
                fontFamily: "Inter",
            }
        },
        MuiInputBase: {
            input: {
                fontFamily: "Inter",
                fontSize: 14,

            }
        },
        MuiOutlinedInput: {
            input: {
                "&::placeholder": {
                    fontStyle: 'italic'
                },
            }
        }
    },
})